<script setup lang="ts">
import UpsellModuleIcon from './UpsellModuleIcon.vue'
import UpsellModuleModal from './UpsellModuleModal.vue'

const { t } = useI18n()

const showUpsellModal = ref(false)
</script>

<template>
  <div class="mb-6 flex flex-1 flex-col items-center gap-6 rounded-2xl bg-brand-gradient p-6 lg:flex-row">
    <div class="flex flex-col flex-1 gap-6 items-center sm:flex-row">
      <div class="flex items-center justify-center">
        <UpsellModuleIcon noBorderGradient :module="'e-reputation'" />
      </div>

      <div class="flex flex-col sm:gap-1 gap-3">
        <h1 class="text-xl font-semibold text-white sm:text-start text-center">{{ t('pages.upsell.banner.title') }}</h1>

        <p class="text-white sm:text-start text-center">
          {{ t('pages.upsell.banner.description') }}
        </p>
      </div>
    </div>

    <Button
      class="text-base! py-3! px-6! font-bold text-primary! bg-white! hover:bg-primary/10! flex flex-row gap-2 items-center justify-center"
      @click="showUpsellModal = true"
    >
      {{ t('pages.upsell.banner.cta') }}
    </Button>
  </div>
  <UpsellModuleModal :module="'e-reputation'" :show="showUpsellModal" @close="showUpsellModal = false" />
</template>
